import { BaseError } from "./BaseError";
/**
 * Argument null error
 */ export class ArgumentNullError extends BaseError {
    constructor(argumentName, errorMessage){
        super(), this.argumentName = argumentName, this.errorMessage = errorMessage;
        if (argumentName) {
            this.message = `${argumentName} cannot be null. ${errorMessage || ""}`.trim();
        } else {
            this.message = errorMessage || "";
        }
        this.name = "ArgumentNullError";
    }
}
